export const FETCH_COUNT_PER_PAGE = 60
